// const URL = "https://crmbk.keelis.in/"; // live server
// const URL = "https://accounts.keelis.in/"; //Accounts
// const URL = "13.234.176.236:80001"; //AWS
// const URL = "https://accountsbk.keelis.in/"; // Testing Server Old
const URL = "http://crmdevbk.athithishala.com/"; //Development
// const URL = "https://crmdemobk.keelis.in/"; // Demo
// const URL = "http://crmtestbk.athithishala.com/" //Testing Server New
// const URL = "https://crmtest.keelis.in/";
// const URL = "http://crmbackupbk.keelis.in/"; //Backup Server
// const URL = "crmbk.keelis.in/"  // live server
// const URL = "https://crmgalaxydemobk.keelis.in/"; //Galaxy Demo
// const URL = "https://crmshakirdemobk.keelis.in/"; //Shakir Demo
// const URL = "http://www.crmcitypestdemobk.keelis.in/"; //City Types Demo
// const URL = "https://egcrmbk.athithishala.com/" //EverGuard Single Login

export default URL;
